import {ContactsManagerPanelId} from '../../../../../../src/store/panels/panelStateBase';
import {createMandatoryContext} from '../../../../../shared/helpers/src/react/reactHelpers';
import {ContactsManagerTrackEventHandler} from './helpers/trackingHelpers';

/*
 * Props.
 */

export interface ContactsManagerContextProps {
  panelId: ContactsManagerPanelId;
  onTrackHandler: ContactsManagerTrackEventHandler;
}

/*
 * Context.
 */

export const [ContactsManagerContext, useContactsManagerContext] =
  createMandatoryContext<ContactsManagerContextProps>();
